export function useSomethingWrongPopup(textObject = null) {
  const router = useRouter()
  const popup = usePopup()
  const { tmsafe } = useI18nUtils()
  const localePath = useLocalePath()

  const { title, text, cta } = textObject ?? (tmsafe("errors.something_wrong") as any)

  const handleAction = () => {
    popup.close()
    router.push(localePath({ name: "index" }))
  }

  const openSomethingWrongPopup = (errorObject: any = null) => {
    return popup.open({
      type: "warning",
      title,
      content: text,
      classes: { body: "text-center" },
      action: {
        label: cta,
        action: handleAction,
      },
      close: handleAction,
      errorObject,
    })
  }

  return { openSomethingWrongPopup }
}
